import { render, staticRenderFns } from "./TransServicesOverview.vue?vue&type=template&id=daff1592"
import script from "./TransServicesOverview.vue?vue&type=script&lang=ts"
export * from "./TransServicesOverview.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports